<template>
  <el-menu
    ref="menu"
    menu-trigger="click"
    :unique-opened="true"
    :background-color="topBarMainColor"
    activ-text-color="#ffffff"
    text-color="#ffffff"
    mode="horizontal"
  >
    <a href="/" v-if="enabledFunctions.includes(ENABLED_FUNCTIONS.LOGO)" helpy="main-page" @click.prevent="redirectToLandingPage">
      <img class="creator-logo" :src="logoSource" alt="Alt" />
    </a>
    <span v-if="enabledFunctions.includes(ENABLED_FUNCTIONS.SYS_CAPTION) && systemCaption" class="sys-caption">
      {{ $i18n.t(systemCaption) }}
    </span>
    <el-submenu
      index="0"
      class="submenu right-menu-item"
      v-if="enabledFunctions.includes(ENABLED_FUNCTIONS.LANGUAGE)"
      v-click-outside="close"
      helpy="language-selector-flag"
    >
      <template slot="title">
        <country-flag :country="activeLang" size="normal" />
      </template>
      <lang-switcher></lang-switcher>
    </el-submenu>
    <el-submenu
      index="1"
      class="submenu right-menu-item"
      v-if="enabledFunctions.includes(ENABLED_FUNCTIONS.PROFILE_MENU)"
      v-click-outside="close"
      helpy="profile-menu"
    >
      <template slot="title"><img class="profile-picture" :src="profilePictureUrl" alt="Profil" /></template>
      <user-menu v-bind="avatarProps"></user-menu>
    </el-submenu>

    <div
      class="right-menu-item d-flex align-items-center justify-content-center noti-center"
      v-if="enabledFunctions.includes(ENABLED_FUNCTIONS.NOTIFICATION)"
      helpy="notification-bell"
    >
      <notification-center></notification-center>
    </div>

    <div
      class="right-menu-item d-flex align-items-center justify-content-center"
      v-if="enabledFunctions.includes(ENABLED_FUNCTIONS.HELPY)"
      helpy="default-helpy"
    >
      <el-button class="topbar-button" type="text" @click="showHelpy = !showHelpy">
        <i class="material-icons icon-helpy icon-align">question_mark</i>
      </el-button>
    </div>

    <el-drawer size="100%" :visible.sync="showHelpy" :title="$i18n.t('helpy_modal_title')" append-to-body>
      <helpy />
    </el-drawer>

    <div v-if="showTour" class="right-menu-item d-flex align-items-center justify-content-center">
      <el-button class="topbar-button" type="text" @click="onStartTour">
        <i class="material-icons icon-align">play_circle</i>
      </el-button>
    </div>

    <tour :steps="tourSteps" :startTour="startTour" @stopTour="onStopTour()"></tour>
  </el-menu>
</template>

<script>
/**
 * @class TopBar
 *
 * @description topbar component for ui
 */

import LangSwitcher from './LangSwitcher.vue'
import UserMenu from './UserMenu'
import CountryFlag from 'vue-country-flag'
import NotificationCenter from '../notification/NotificationCenter'
import { helpyTypes } from '../helpy-designer/helpyTypes'
import helpyStore from '../../store/modules/helpy'
import Tour from '../tour-guide/Tour'
import Helpy from '../helpy/Helpy'
import EventBus from '../../utils/event-bus'
import { get } from 'lodash'
import file from '../../utils/file'

const ENABLED_FUNCTIONS = {
  LOGO: 'logo',
  SYS_CAPTION: 'sysCaption',
  LANGUAGE: 'language',
  PROFILE_MENU: 'profileMenu',
  NOTIFICATION: 'notification',
  HELPY: 'helpy',
  HELPY_TOUR: 'helpyTour',
}

export default {
  name: 'TopBar',
  instanceStore: {
    name: 'helpyStore',
    module: helpyStore,
  },
  components: {
    NotificationCenter,
    CountryFlag,
    LangSwitcher,
    UserMenu,
    Tour,
    Helpy,
  },
  data() {
    return {
      ENABLED_FUNCTIONS,
      selectedLanguage: get(this.$CORE, 'params.language.code', null),
      avatarProps: {
        user: {
          id: get(this.$CORE, 'params.ID_S_USER', null),
          userName: get(this.$CORE, 'params.userName', ''),
          email: get(this.$CORE, 'params.emailNotified', ''),
          profilePicture: get(this.$CORE, 'externalParams.idProfileDocument', 'static/avatar.png'),
          fullName: get(this.$CORE, 'externalParams.fullName', '')
            ? this.$CORE.externalParams.fullName
            : get(this.$CORE, 'params.userName', ''),
        },
        lockUrl: `/logout`,
      },
      loaded: false,
      activeComponent: '',
      position: 'left',
      body: document.getElementsByTagName('body')[0],
      menuItemOpen: document.getElementsByClassName('open'),
      items: [],
      helpyUrl: `${this.$CORE.helpyUrl}?url=${this.$CORE.url}`,
      tourSteps: [],
      startTour: false,
      systemCaption: get(this.$CORE, 'subSystem.nameLong', null),
    }
  },
  methods: {
    onStopTour() {
      this.startTour = false
    },
    onStartTour() {
      this.startTour = true
    },
    redirectToLandingPage() {
      const landingPage = '/' + window.CORE.landingPage.replace(/^\/*/, '') // @regex levagja a string elejerol a / karaktereket
      this.$router.push({ path: landingPage })
    },
    prepareTour() {
      if (!get(window, 'CORE.params.ID_S_USER')) return

      const tour = this.$CORE.tour || []
      this.tourSteps = tour.map((helpy) => {
        return {
          title: helpy.title,
          content: helpy.content,
          target: helpy.selector,
        }
      })
    },
    setHelpyFilter(filter) {
      this.showHelpy = true
      this.$dispatch('setHelpyFilter', { filter })
    },
    close() {
      const subMenus = document.querySelectorAll('.submenu') || []
      subMenus.forEach((subMenu, index) => {
        if (subMenu.classList.contains('is-opened')) {
          this.$refs['menu'].close(index.toString())
        }
      })
    },
  },
  computed: {
    profilePictureUrl() {
      return this.avatarProps.user.profilePicture
        ? `/download/${this.avatarProps.user.profilePicture}`
        : '/static/avatar.png'
    },
    //@todo kivezetni valahogy a variables.scss-be
    topBarMainColor() {
      if (this.$CORE.subSystem.id === 26) {
        return '#270E66'
      } else {
        return '#270E66'
      }
    },
    logoSource() {
      const topBarLogoSrc = this.$CORE.subSystem.topBarLogo
      return topBarLogoSrc ? file.methods.getStaticImageSource(topBarLogoSrc) : '/static/favicon.ico'
    },
    activeLang() {
      return this.selectedLanguage.slice(-2)
    },
    showHelpy: {
      get() {
        return this.$get('showHelpy')
      },
      set(showHelpy) {
        this.$dispatch('setShowHelpy', { showHelpy })
      },
    },
    isTourEnabled() {
      return this.enabledFunctions.includes(ENABLED_FUNCTIONS.HELPY_TOUR)
    },
    showTour() {
      return this.isTourEnabled && this.tourSteps.length
    },
    enabledFunctions() {
      return this.$store.getters.enabledFunctions || []
    },
  },
  mounted() {
    this.prepareTour()
    EventBus.$on('set-helpy-filter', this.setHelpyFilter)
  },
  beforeDestroy() {
    EventBus.$off('set-helpy-filter')
    this.$store.unregisterModule([this.$storeNamespace])
  },
}
</script>

<style lang="scss" scoped>
.el-menu {
  position: fixed;
  top: 0;
  width: 100%;
  border: none !important;
  z-index: 2000;
  height: $top-bar-height;
}
.right-menu-item {
  height: 100%;
  float: right !important;
}
.logo-container {
  display: flex;
  align-items: center;
}
.creator-logo {
  height: 100%;
  padding: 8px;
}
.noti-center {
  height: 100%;
  padding: 5px 20px;
}
.profile-picture {
  height: 35px;
  width: 35px;
  object-fit: cover;
  border-radius: 50%;
}
.el-menu--popup-bottom-start {
  margin-top: 0px !important;
}
.el-menu--popup {
  border-radius: 0px 0px 6px 6px !important;
}
.topbar-button {
  color: $white;
  border-radius: 50%;
  padding: 10px;
  height: 100%;
}
.icon-helpy {
  background-color: $white;
  color: $color-primary;
  font-size: 14px;
  padding: 3px;
  border-radius: 10px;
}
.icon-helpy:hover {
  background-color: $color-primary-hover;
}
.sys-caption {
  color: $color-text-secondary;
  vertical-align: -webkit-baseline-middle;
  margin-left: 10px;
}
</style>
